const CurrencyEnum = {
    EUR: 'Euro',
    HRK: 'Croatian kuna'
  };

export default CurrencyEnum;